export const Permission = {
    TAXES: 'TAXES',
    TAXES_SUBSCRIPTION_ONBOARDING: 'TAXES_SUBSCRIPTION_ONBOARDING',
    TAX_RETURN: 'TAX_RETURN',
    QUARTERLY_TAX_RETURN: 'QUARTERLY_TAX_RETURN',
    COMPANY_TAX_RETURN: 'COMPANY_TAX_RETURN',
    QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY: 'QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY',
    BOOKKEEPING: 'BOOKKEEPING',
    MESSAGES: 'MESSAGES',
    MESSAGES_SUBSCRIPTION_ONBOARDING: 'MESSAGES_SUBSCRIPTION_ONBOARDING',

    COMPANY_DASHBOARD: 'COMPANY_DASHBOARD',
    SELF_EMPLOYED_ONBOARDING_DASHBOARD: 'SELF_EMPLOYED_ONBOARDING_DASHBOARD',
    SELF_EMPLOYED_DASHBOARD: 'SELF_EMPLOYED_DASHBOARD',
    PREMIUM_SELF_EMPLOYED_DASHBOARD: 'PREMIUM_SELF_EMPLOYED_DASHBOARD',
    RENTA_DASHBOARD: 'RENTA_DASHBOARD',
    QTR_ANNUAL_DASHBOARD: 'QTR_ANNUAL_DASHBOARD',
    CANCELLED_SUBSCRIPTION_DASHBOARD: 'CANCELLED_SUBSCRIPTION_DASHBOARD',
    DASHBOARD_LINK: 'DASHBOARD_LINK',

    SUBSCRIPTION_CROSS_SELL: 'SUBSCRIPTION_CROSS_SELL',
} as const

export type PermissionType = (typeof Permission)[keyof typeof Permission]
